<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='product-grid'>
      <dx-data-grid ref='refSemiProductGrid'
        :data-source='rawMaterialInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="true"
        key-expr="품번"
        :focused-row-key.sync='focusedRowKey'
        @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated' @row-updating='onUpdating'
        @editor-preparing='onEditorPreparing'
        @init-new-row='onInitNewRow'
        @context-menu-preparing="addMenuItems"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="productType"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="true"
          :allow-updating="true"
          :allow-adding="true"
          :use-icons="true"
          :mode='batchEdit ? "batch":"popup"'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="350"
            title="품록등록"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
            <DxItem
            :col-count="2"
            :col-span="2"
            item-type="group"
            >
              <DxItem data-field="납품처코드"/>
              <DxItem v-if="$store.getters.getGroupName !== null" data-field="차종"/>
              <DxItem data-field="품번"/>
              <DxItem data-field="품명"/>
              <DxItem data-field="품목유형"/>
              <DxItem data-field="공정유형"/>
              <DxItem data-field="도급"/>
              <DxItem data-field="외주가공비"/>
              <DxItem data-field="거래처코드"/>
              <DxItem data-field="단위"/>
              <DxItem data-field="재질"/>
              <!-- <DxItem data-field="uph"/> -->
              <DxItem data-field="생산로트수량"/>
              <!--
              <DxItem data-field="도급"/>
              <DxItem data-field="cycletime"/>
              <DxItem data-field="주문lot"/>
              <DxItem data-field="규격"/>
              -->
              <DxItem data-field="라인코드"/>
              <DxItem data-field="사용유무"/>
              <!--
              <DxItem data-field="삭제유무"/>
              -->
            </DxItem>
          </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          width="90"
          :buttons="editButtons"
          type="buttons"
        />
        <DxColumn
          :allowEditing='true'
          caption="고객사"
          data-field="납품처코드"
          :visible='true'
        >
          <DxLookup
            :data-source="companyInfoLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='true'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          :visible='true'
          width="70"
        >
           <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='isIdEdit'
          caption="품번"
          data-field="품번"
          sort-order='asc'
          width="120"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
          :visible='true'
          width="130"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing="isSemiPress()"
          caption="재질"
          data-field="재질"
          :visible='true'
          width="160"
        >
          <!-- <dx-required-rule message="항목을 선택하세요" v-if="isSemiPress()"/> -->
          <DxLookup
            :data-source="rawMeterialTypeLookup"
            display-expr="재질"
            value-expr="재질"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
         <DxColumn
          :allowEditing='true'
          caption="자작/도급"
          data-field="도급"
          :visible='true'
        >
          <dx-required-rule message="항목을 선택하세요"/>
          <DxLookup
            :data-source="consignedLookup"
            display-expr="코드"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="도급가공비"
          data-field="외주가공비"
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="도급거래처"
          data-field="거래처코드"
          :visible='true'
        >
          <DxLookup
            :data-source="$store.getters.getPartnersInfo"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="라인명"
          data-field="라인코드"
          :visible='true'
          edit-cell-template="lineGridTemplate"
        >
          <DxLookup
            :data-source="productionLineLookup"
            display-expr="라인명"
            value-expr="라인코드"
          />
        </DxColumn>
        <!-- <DxColumn
          :allowEditing='false'
          caption="투입인원"
          data-field="표준공수"
          :visible='false'
          format='#,##0.0'
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="사이클(분)"
          data-field="cycletime"
          :visible='false'
          format='#,##0.0'
          dataType="number"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn> -->
        <DxColumn
          :allowEditing='false'
          caption="생산 Lot"
          data-field="주문lot"
          :visible='false'
          format='#,##0'
          dataType="number"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="규격"
          data-field="규격"
          :visible='false'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <dx-required-rule message="항목을 선택하세요"/>
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <!-- <DxColumn v-if="isSemiPress()"
          :allowEditing='true'
          caption="UPH"
          data-field="uph"
          dataType="number"
          :visible='true'
        >
          <dx-required-rule message="시간당 생산 수량을 입력 하세요."/>
        </DxColumn> -->
        <DxColumn v-if="isSemiPress()"
          :allowEditing='true'
          caption="생산로트수량"
          data-field="생산로트수량"
          dataType="number"
          :visible='true'
        >
          <dx-required-rule message="생산로트수량을 입력 하세요."/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="삭제유무"
          data-field="삭제유무"
          :visible='false'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="등록일"
          data-field="createtime"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :visible='true'
          caption="수정일"
          data-field="updatetime"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <template #lineGridTemplate="{ data: cellInfo }">
            <LineGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-line='setLineCode'
              :lineInfo='productionLineLookup'
            />
          </template>
      </dx-data-grid>
    </div>
    <DxPopupGen v-if='qrOptions !== null'
      :visible.sync="popupQrcode"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="500"
      :height="590"
      :title="qrCodePopupTitle"
    >
      <SerailNoQrPrintComponent :qr-options="qrOptions"/>
    </DxPopupGen>
    <DxPopupGen v-if="popupDokubPrice"
      :visible.sync="popupDokubPrice"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="400"
      :height="450"
      title="도급가 일괄등록"
    >
      <div>
        <dx-data-grid
          ref="refPurchasePriceInfoList"
          :data-source='dokubPriceInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          height='370'
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="품번"
          @toolbar-preparing='onToolbarPreparingDokubCost'
        >
          <DxColumn
            :allowEditing='true'
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="도급가"
            data-field="외주가공비"
            format='#,##0.00'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="비고"
            data-field="비고"
            width="100"
          >
          </DxColumn>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
    </DxPopupGen>
    <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import axios from 'axios'
import SerailNoQrPrintComponent from '../../share/component/SerailNoQrPrintComponent'
import LineGridComponent from '../../share/component/LineGridComponent'
import ExcelJS from 'exceljs'

export default {
  name: 'login',
  props: {
  },
  data: function () {
    return {
      isLoading: false,
      editButtons: ['edit', 'delete',
        {
          hint: 'QR Code 보기',
          icon: 'print',
          visible: 'true',
          onClick: this.onClickPopupQrCode
        }],
      rawMaterialInfoList: null,
      gridHeight: null,
      userInfo: null,
      selectedRow: null,
      itemTypeLookup: null,
      unitLookup: null,
      focusedRowKey: null,
      processingTypeLookup: null,
      rawMeterialTypeLookup: null,
      productType: ConstDef.구매품,
      companyInfoList: [],
      isIdEdit: true,
      divisionList: null,
      bomList: null,
      selectedLineCode: null,
      qrOptions: null,
      printQrCount: 10,
      carTypeLookup: null,
      customerLookup: null,
      batchEdit: false,
      consignedLookup: null,
      productionLineLookup: null,
      companyInfoLookup: null,
      // 팝업
      isEditDate: false,
      // 도급가 일괄등록
      popupDokubPrice: false,
      dokubPriceInfoList: null

    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxForm,
    DxItem,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxScrolling,
    DxPopupGen,
    SerailNoQrPrintComponent,
    LineGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.carTypeLookup = this.$store.getters.getCarType
    this.customerLookup = this.$store.getters.getCustomerInfo
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.rawMeterialTypeLookup = this.$store.getters.getRawMeterial
    this.companyInfoList = this.$store.getters.getPartnersInfo
    this.consignedLookup = ConstDef.도급_LOOKUP
    this.companyInfoLookup = this.$store.getters.getFirstVendor
    this.refreshDivision()
    this.refreshLine()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    addMenuItems (e) {
      if (e.target === 'content') {
        e.items = []
        e.items.push({
          text: 'QR 코드 출력',
          icon: 'print',
          onItemClick: () => {
            this.qrCodePopupTitle = `입출고 QR 코드용 프린팅(${e.row.data.품번})`
            // let base64 = AesCrypto.base64Encode(e.row.data.품번)
            this.qrOptions = { title: e.row.data.품번, data: `${AppLib.getBase64SameLength(e.row.data.품번)}`, cellSize: 5 }
            this.popupQrcode = true
          }
        })
      }
    },
    isSemiPress (row) {
      return (this.productType === ConstDef.다공정품)
    },
    onClickPopupQrCode (e) {
      this.qrCodePopupTitle = `입출고 QR 코드용 프린팅(${e.row.data.품번})`
      // let base64 = AesCrypto.base64Encode(e.row.data.품번)
      this.qrOptions = null
      this.qrOptions = { title: e.row.data.품번, data: `${AppLib.getBase64SameLength(e.row.data.품번)}`, cellSize: 5 }
      this.popupQrcode = true
    },
    onQrUpdated (e) {
      this.$Q('.qr-code-wrap').css('width', e.width + 'px')
    },
    onClickSearchBom (e) {
    },
    searchChildBomProduct (bomList) {
      for (let i = 0; i < bomList.length; i++) {
        if (bomList[i].품목유형 === ConstDef.다공정품) {
          this.$_sp.runNoEncodeFindProc('spFindAllSemiBomByTopCode', { 최상위품번: bomList[i].품번 })
            .then((data) => {
              let rep = this.$_sp.MakeModel(data)
              this.bomList = this.$_.uniq(
                this.$_.union(bomList, rep), false, function (item, rep) { return item.품번 }
              )
            })
            .catch(error => {
              this.isLoading = false
              if (error.response.status === ConstDef.GENERRAL_ERROR) {
                this.$snotify.error(error.response.data.message)
              } else {
                this.$snotify.error(`에러코드 : ${error.response.status}`)
              }
            })
        }
      }
    },
    onEditorPreparing (e) {
      if (e.dataField === '품번' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      // // console.log(row)
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.품목유형 = this.productType // 구매품
    },
    onRowInserted (row) {
      // // console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userName
      if (row.data.도급 !== '도급') {
        row.data.거래처코드 = null
        row.data.외주가공비 = null
        row.data.거래처명 = null
      }
      if (row.data.납입품번 === undefined) {
        row.data.납입품번 = row.data.품번
      }

      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      let goods = this.$_sp.runInsertSqlProc('품목정보', ['거래처명', '담당부서', '라인명'], array)
      let param = {
        이월일자: `${row.data.createtime.substring(0, 7)}-01`,
        품번: row.data.품번,
        createid: this.userInfo.userId
      }
      // // console.log(param)
      const stock = this.$_sp.runUpdateProc('spSaveCurrentStock', [param])

      axios.all([goods, stock])
        .then(axios.spread((...reponse) => {
          this.focusedRowKey = row.data.품번
          this.$snotify.info('저장 되었습니다.')
          if (this.productType === ConstDef.다공정품) {
            const url = `/main/scrapCost?품번=${row.data.품번}&품명=${row.data.품명}&품목유형=${ConstDef.다공정품}`
            window.open(url, '_blank')
          }
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInserting (row) {
      if (this.$_.findIndex(this.rawMaterialInfoList, { 품번: row.data.품번 }) >= 0) {
        this.$snotify.error('품번이 중복되었습니다.')
        row.cancel = true
      }
      if (row.data.도급 === '도급') {
        if (row.data.거래처코드 === undefined) {
          this.$snotify.info('도급 공정인 경우 거래처를 선택하여 주세요.')
          row.cancel = true
        }
        if (row.data.외주가공비 === undefined) {
          this.$snotify.info('도급 공정인 경우 도급가공비를 입력하여야 합니다.')
          row.cancel = true
        }
      }
      if (row.data.품목유형 === ConstDef.다공정품) {
        if (!((row.data.품번).includes(':')) && row.data.재질 === undefined) {
          this.$snotify.info('재질을 선택하여 주세요.')
          row.cancel = true
        }
      }
    },
    async onRowRemoved (row) {
      this.isLoading = true
      await this.$_sp.runNoEncodeFindSqlProc('BOM차종', { 품번: row.data.품번 })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.$snotify.error('양산 차종에 등록된 완제품 입니다')
            this.rawMaterialInfoList.push(row.data)
            this.$refs.refSemiProductGrid.instance.refresh()
            this.focusedRowKey = row.data.품번
            this.isLoading = false
          }
        })
      if (this.isLoading === false) return
      await this.$_sp.runNoEncodeFindSqlProc('BOM정전개', { 품번: row.data.품번 })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.$snotify.error('BOM 구성이 되어있는 제품 입니다.')
            this.rawMaterialInfoList.push(row.data)
            this.$refs.refSemiProductGrid.instance.refresh()
            this.focusedRowKey = row.data.품번
            this.isLoading = false
          }
        })
      if (this.isLoading === false) return
      this.$_sp.runUpdateProc('spDeleteGoodsInfo', [{ 품번: row.data.품번 }])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onUpdating (row) {
      if (row.newData.공정유형 !== undefined && row.newData.도급 === '도급') {
        if (row.newData.외주가공비 === undefined) {
          this.$snotify.info('도급 공정인 경우 외주가공비를 입력하여야 합니다.')
          row.cancel = true
        }
        if (row.newData.거래처명 === undefined) {
          this.$snotify.info('도급 공정인 경우 거래처를 선택하여 주세요.')
          row.cancel = true
        }
      }
    },
    onRowUpdated (row) {
      // // console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      row.data.구매단위 = row.data.단위
      if (row.data.도급 !== '도급') {
        row.data.거래처코드 = null
        row.data.외주가공비 = null
        row.data.거래처명 = null
      }
      if (row.data.납입품번 === null || row.data.납입품번.length === 0) {
        row.data.납입품번 = row.data.품번
      }
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('품목정보', ['품번'], ['거래처명', '라인명'], array)
        .then((data) => {
          if (this.batchEdit === false) {
            this.$snotify.info('저장 되었습니다.')
          }
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.batchEdit,
            text: '일괄수정',
            onValueChanged: (args) => {
              this.batchEdit = args.value
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '도급단가 일괄등록',
            icon: 'save',
            text: '도급단가 일괄등록',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.dokubPriceInfoList = []
              this.popupDokubPrice = true
            }
          }
        }
      )
    },
    refreshCarType () {
      this.$_sp.runNoEncodeFindSqlProc('고객사생산품목', null)
        .then((data) => {
          this.carTypeLookup = this.$_.sortBy(this.$_sp.MakeModel(data), '모델명')
        })
    },
    refreshDivision () {
      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
        })
    },
    refreshLine () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.productionLineLookup = this.$_sp.MakeModel(data)
        })
    },
    refreshProduct (type) {
      // // console.log(type)
      this.productType = type
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllProductByTypeWithCarType', { 품목유형: type })
        .then((data) => {
          this.rawMaterialInfoList = this.$_sp.MakeModel(data)
          // console.log(this.rawMaterialInfoList)
          this.gridHeight = (screen.height - 250) * 0.95
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshRawMeterialLookup () {
      this.$_sp.runNoEncodeFindProc('spFindAllRawMeterialLookup', {})
        .then((data) => {
          this.rawMeterialTypeLookup = this.$_sp.MakeModel(data)
          // console.log(this.rawMeterialTypeLookup)
        })
    },
    // emit compnay search
    setLineCode (code) {
      this.selectedLineCode = code
      console.log(this.selectedLineCode)
    },
    // 팝업
    onEditorPreparingPriceDate (e) {
      if (e.dataField === '가격' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isEditDate = true
        } else {
          this.isEditDate = false
        }
        console.log(this.isEditDate)
      }
    },
    // 도급가 일괄등록
    onDetailFileChange: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      const vm = this
      reader.onloadend = function (event) {
        console.log('reader.onloadend')
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          let worksheet = workbook.worksheets[0]
          console.log(worksheet)
          let row = null
          for (let i = 2; i < 1000; i++) {
            let temp = {}
            row = worksheet.getRow(i)
            temp.품번 = AppLib.getCellFromExcel(row, 1)
            if (temp.품번 === null) {
              console.log(`read row=${i - 1}`)
              break
            }
            temp.외주가공비 = AppLib.getCellFromExcel(row, 2)
            temp.도급 = '도급'
            console.log(temp)
            vm.dokubPriceInfoList.push(temp)
          }
        })
      }
      reader.readAsArrayBuffer(file)
    },
    onToolbarPreparingDokubCost (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '도급단가 일괄등록',
            icon: 'exportxlsx',
            text: '엑셀파일선택',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '도급단가 일괄저장',
            icon: 'save',
            text: '일괄저장',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              console.log(this.dokubPriceInfoList)
              if (this.dokubPriceInfoList.length === 0) {
                this.$snotify.error('등록할 도급 단가가 없습니다.')
                return
              }
              this.$snotify.confirm(`도급단가를 등록 하시겠습니까?`, '', {
                timeout: 10000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '등록',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                      this.saveDokubPrice(this.dokubPriceInfoList)
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    saveDokubPrice (list) {
      this.isLoading = true
      this.$_sp.runUpdateSqlProc('품목정보', ['품번', '도급'], null, list)
        .then(data => {
          this.$snotify.info('저장 되었습니다.')
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
</style>
